import React, { useMemo } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faChartBar, faChartPie } from '@fortawesome/free-solid-svg-icons';

interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    borderColor: string;
    backgroundColor: string;
    fill?: boolean;
  }[];
}

interface FacebookMetricsChartProps {
  title: string;
  data: ChartData;
  type: 'line' | 'bar' | 'pie';
  height?: number;
  className?: string;
}

export const FacebookMetricsChart: React.FC<FacebookMetricsChartProps> = ({
  title,
  data,
  type,
  height = 300,
  className = ''
}) => {
  const chartIcon = useMemo(() => {
    switch (type) {
      case 'line':
        return faChartLine;
      case 'bar':
        return faChartBar;
      case 'pie':
        return faChartPie;
      default:
        return faChartLine;
    }
  }, [type]);

  const hasData = useMemo(() => {
    return data.datasets.some(dataset => 
      dataset.data.some(value => value > 0)
    );
  }, [data]);

  if (!hasData) {
    return (
      <Card className={`metrics-chart ${className}`}>
        <CardHeader>
          <h4>{title}</h4>
        </CardHeader>
        <CardBody>
          <div className="no-data-placeholder">
            <FontAwesomeIcon icon={chartIcon} size="2x" />
            <p>No hay datos disponibles para este período</p>
          </div>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className={`metrics-chart ${className}`}>
      <CardHeader>
        <h4>{title}</h4>
      </CardHeader>
      <CardBody>
        <div className="chart-container" style={{ height: `${height}px` }}>
          {/* Aquí se integraría Chart.js o la librería de gráficos preferida */}
          <div className="chart-placeholder">
            <FontAwesomeIcon icon={chartIcon} size="3x" />
            <p>Gráfico de {type}</p>
            <small>Datos: {data.datasets.length} series, {data.labels.length} puntos</small>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
